import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Autocomplete from '@/common/Autocomplete/Autocomplete.vue';
import useOrganizationsAutocompleteDataSource from '@/hooks/useOrganizationsAutocompletedDataSource';
import { useUserStore } from '@/stores';
import { OrganizationTypeDS } from '@/dialogs/OrganizationDialog/types/Organization';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationAutocomplete',
  setup(__props) {


const userStore = useUserStore();
const organizationsDS = useOrganizationsAutocompleteDataSource();

const changeOrganization = (organization: OrganizationTypeDS) => {
  if (organization.id) {
    userStore.fetchOrganization({
      params: {
        organization: organization.id,

      },
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Autocomplete, {
    "model-value": _unref(userStore)?.user?.organization,
    "item-text": "title",
    "item-value": "id",
    "use-input": false,
    outlined: "",
    dense: "",
    dark: "",
    filled: "",
    "popup-content-style": "width: 300px",
    style: {"padding":"0"},
    class: "full-width",
    label: _ctx.$t('organizations.currentOrganization'),
    "data-source": _unref(organizationsDS),
    load: "",
    "onUpdate:modelValue": changeOrganization
  }, null, 8, ["model-value", "label", "data-source"]))
}
}

})